import { styled } from '@mui/material/styles';
import MuiPaper from '@mui/material/Paper';

export const StyHeader = styled('p', {
    name: 'StyHeader',
})({
    marginTop: '10px',
});

export const StyHighlightedText = styled('span', {
    name: 'StyHighlightedText',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 550,
}));

export const StyColouredText = styled('span', {
    name: 'StyHighlightedText',
})(({ theme }) => ({
    color: theme.palette.primary.main,
}));

export const StyPaper = styled(MuiPaper, {
    name: 'StyPaper',
})({
    padding: '6px 16px',
});
